import { Box, Button } from '@mui/material';
import { GridFilterPanel, GridFilterPanelProps, useGridApiContext } from '@mui/x-data-grid-pro';
import React from 'react';
import { useFeatureToggles } from '../../feature-toggles';

export const dataGridFilterPanelOkButtonToggle = 'EnableDataGridFilterPanelOkButton';

export function FasitFilterPanel(props: GridFilterPanelProps) {
  const apiRef = useGridApiContext();
  const { isFeatureEnabled } = useFeatureToggles();

  if (!isFeatureEnabled(dataGridFilterPanelOkButtonToggle)) {
    return <GridFilterPanel {...props} />;
  }

  function handleOkClick() {
    apiRef.current.hideFilterPanel();
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1, minWidth: 0 }}>
      <GridFilterPanel {...props} />
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', px: 1, pb: 1 }}>
        <Button variant="contained" size="small" onClick={handleOkClick}>
          OK
        </Button>
      </Box>
    </Box>
  );
}
